<h2 mat-dialog-title>Agregar botones a "Servicios o Trámites"</h2>

<mat-dialog-content>
  <p class="intro">
    Buscá botones ya creados y marcá los que querés sumar. El orden se arma
    después, arrastrándolos en la sección.
  </p>

  <mat-form-field appearance="outline" class="buscador">
    <mat-label>Buscar botón</mat-label>
    <input
      matInput
      [(ngModel)]="busqueda"
      [ngModelOptions]="{ standalone: true }"
    />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <div class="lista">
    @for (fila of filasFiltradas; track fila.boton._id) {
      <div
        class="fila"
        [class.seleccionada]="seleccionados.has(fila.boton._id ?? '')"
        (click)="toggle(fila)"
      >
        <mat-checkbox
          [checked]="seleccionados.has(fila.boton._id ?? '')"
          (click)="$event.stopPropagation(); toggle(fila)"
        />
        <div class="fila-datos">
          <strong>{{ fila.etiqueta }}</strong>
          @if (fila.boton.funcion) {
            <span class="pill">{{ fila.boton.funcion }}</span>
          }
        </div>
      </div>
    } @empty {
      <p class="vacio">No hay botones que coincidan.</p>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cerrar()">Cancelar</button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="!seleccionados.size"
    (click)="agregar()"
  >
    Agregar {{ seleccionados.size || "" }}
  </button>
</mat-dialog-actions>
